export default "__VITE_ASSET__402959cb__"